import { UserRole } from 'Application/models';
import { getUserDataFromStorage } from 'Application/utils';
import { mapUserRoleToHomeRoute } from 'Application/utils';
import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    component: ReactNode;
    requiredRoles: UserRole[];
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ component, requiredRoles }) => {
    const user = getUserDataFromStorage();

    if (user === null) {
        return <Navigate to={'/'} state={{ from: window.location.pathname }} replace />;
    }

    const userRole = user.role;

    if (requiredRoles.includes(userRole)) {
        return component;
    }

    const homeRoute = mapUserRoleToHomeRoute(userRole);

    return <Navigate to={homeRoute} state={{ from: window.location.pathname }} replace />;
};
